import { Module } from 'vuex'
import { RootState } from '@/store'
import { Project } from '@/api/model/project'
import { actions } from '@/store/projects/actions'
import { mutations } from '@/store/projects/mutations'
import { getters } from '@/store/projects/getters'

export interface ProjectsState {
    loading: boolean,
    error: string|null,
    projects: Project[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    activeFilter: number[],
    companyFilter: string|null,
    nameFilter: string|null,
}

const state: ProjectsState = {
    loading: false,
    error: null,
    projects: [],
    totalItems: null,
    totalPages: 0,
    page: 1,
    itemsPerPage: 10,
    orderField: 'updatedAt',
    orderDirection: 'desc',
    activeFilter: null,
    companyFilter: null,
    nameFilter: null,
}

export const ProjectsModule: Module<ProjectsState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
